export default "__VITE_ASSET__df861a3d__"